<template>
    <!-- Page Content -->
    <div class="d-lg-flex half">
        <div class="bg partner-bg order-1 order-md-1"></div>
        <div class="contents bg-white order-2 order-md-2">
            <div class="container">
                <div class="row align-items-center justify-content-center">
                    <div class="col-md-7 py-4">
                        <div class="text-center mb-4">
                            <a :href="$router.resolve({ name: 'home' }).href" class="navbar-brand logo mr-0">
                                <img src="@/assets/img/logo.png" class="img-fluid" alt="Logo">
                            </a>
                        </div>
                        <h3>Devenez Partenaire</h3>
                        <form @submit.prevent="register">
                            <span class="separator py-2 text-sm">Info d'Espace</span>
                            <div class="form-group card-label h-100 mb-3">
                                <label class="bg-light">Nom</label>
                                <input type="text" id="business_name" class="form-control"
                                    v-model="vendorData.business_name" required="">
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Adresse</label>
                                        <input type="text" id="address" class="form-control"
                                            v-model="vendorData.address" required="">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Délégation</label>
                                        <v-select :options="delegations" v-model="vendorData.delegation" label="option" :reduce="option => option" class="custom-vs form-control input" :class="{ invalid: errors.delegation }">
                                            <template #option="{ option }">
                                                <span><b>{{ option.split(', ')[0]}}</b>, {{ option.split(', ')[1] }}</span>
                                            </template>
                                        </v-select>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <a href="javascript:void(0)" class="text-sm text-muted d-flex align-items-center" @click="showMap = true">
                                        <span class="material-symbols-outlined h5 mb-0 mr-1">globe_location_pin</span> Cliquez ici pour sélectionner votre emplacement sur la carte
                                    </a>
                                </div>
                            </div>
                            <div class="row d-none">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Longitude</label>
                                        <input type="text" id="longitude" class="form-control"
                                            v-model="vendorData.longitude" readonly>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Latitude</label>
                                        <input type="text" id="latitude" class="form-control"
                                            v-model="vendorData.latitude" readonly>
                                    </div>
                                </div>
                            </div>
                            <div class="separator py-2 text-sm">Contact</div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Nom Complet</label>
                                        <input type="text" id="first_name" class="form-control"
                                            v-model="vendorData.full_name" required="">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">E-mail</label>
                                        <input type="email" id="email" class="form-control" :class="{ invalid: errors.email }" v-model="vendorData.email"
                                            required="">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">N° Téléphone</label>
                                        <input type="text" class="form-control" :class="{ invalid: errors.phone_number }"
                                        v-model="vendorData.phone_number" pattern="[1-9][0-9]{7}" required="">
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">N° Whatsapp</label>
                                        <input type="text" id="phone" class="form-control" :class="{ invalid: errors.whatsapp_number }"
                                            v-model="vendorData.whatsapp_number" pattern="[1-9][0-9]{7}" required="">
                                            <div v-if="errors.whatsapp_number" class="invalid-feedback">
                                            {{ errors.whatsapp_number }}
                                            </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group card-label h-100 mb-3">
                                        <label class="bg-light">Mot de passe</label>
                                        <input type="password" min="8" id="password" class="form-control"
                                            v-model="vendorData.password" required="">
                                    </div>
                                </div>
                            </div>
                            <div class="form-group h-100 mb-0 mt-1 text-xs text-black-50">
                                <label class="d-inline">En cliquant sur "Enregistrer", vous acceptez
                                    <a href="/cgu" target="_blank" style="text-decoration: underline">nos Conditions d'Utilisation</a> et
                                    <a href="/privacy-policy" target="_blank" style="text-decoration: underline">notre Politique de
                                        Confidentialité</a>.
                                </label>
                            </div>
                            <!-- <span class="text-danger text-xs d-block my-2" role="alert">{{ errorMsg }}</span> -->
                            <button class="btn btn-primary btn-block btn-lg btn-rounded h4" type="submit"
                                @click="clearForm()">Enregistrer</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Fullscreen map overlay -->
    <div v-if="showMap" class="map-overlay">
        <GoogleMap class="w-100" style="height: 100vh;" :center="mapCenter" :zoom="10" :options="{mapTypeId: 'hybrid'}" @click="handleMapClick">
            <!-- Marker at selected position -->
            <Marker v-if="selectedPosition" :options="{ position: selectedPosition }" />
        </GoogleMap>

        <!-- Close button -->
        <a href="javascript:void(0)" class="material-symbols-outlined h3 mb-0 close-btn bg-light p-2 btn" @click="showMap = false">close</a>
    </div>
    <!-- /Page Content -->
</template>
<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: rgba(0, 0, 0, 0.35);
}

.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.separator:not(:empty)::before {
  margin-right: .45em;
}

.separator:not(:empty)::after {
  margin-left: .45em;
}
.map-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: white;
    z-index: 9999;
}
.close-btn {
    position: absolute;
    top: 10px;
    left: 10px;
}
</style>
<script>
import { GoogleMap, Marker } from 'vue3-google-map'
import vSelect from "vue-select";
import { api } from '@/store';
import { mapActions } from 'vuex';

import "vue-select/dist/vue-select.css";
export default {
    components: {
        GoogleMap,
        Marker,
        vSelect
    },
    data() {
        return {
            errors: {},
            delegations: [],
            vendorData: {
                business_name: '',
                vat_id: '',
                address: '',
                delegation: '',
                description: '',
                longitude: -10.00,
                latitude: -10.00,
                full_name: '',
                email: '',
                phone_number: '',
                whatsapp_number: '',
                password: '',
            },
            mapCenter: { lat: 36.8065, lng: 10.1815 },
            showMap: false,
            selectedPosition: null,
        }
    },
    created() {
        this.getDelegations()
    },

    methods: {
        ...mapActions(['login']), // Map login action from Vuex store
        getDelegations() {
            api.get('/core/static/regions/delegations')
                .then(response => {
                    const result = response.data
                    this.delegations = result.filter(Boolean)
                })
        },
        async register() {
            try {
                const formData = new FormData();
                formData.append("form_data", JSON.stringify(this.vendorData));
                await api.post('/auth/register-owner', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                    .then(response => {
                        this.$router.push('/index');
                    })
                    .catch(error => {
                        if (error.response) {
                            if (error.response.status === 422) {
                                const rawErrors = error.response.data.detail;
                                rawErrors.forEach(err => {
                                    const field = err.loc[0]; // e.g., "username"
                                    this.errors[field] = err.msg; // e.g., "field required"
                                });
                            }
                        }
                    });
            } catch (error) {
                console.error('Error:', error);
            }
        },
        handleMapClick(event) {
            // Google Maps click event gives latLng object
            const lat = event.latLng.lat();
            const lng = event.latLng.lng();
            this.vendorData.latitude = lat;
            this.vendorData.longitude = lng;
            this.selectedPosition = this.mapCenter = { lat, lng };
        },
        mapValidationErrors(detail) {
            const newErrors = {}
            detail.forEach(err => {
                const field = err.loc[0]; // e.g., "username"
                newErrors[field] = err.msg; // e.g., "field required"
            });
            this.errors = { ...newErrors };
        },
        clearForm() {
            $('.invalid-feedback').remove();
            $('.form-control.is-invalid').removeClass('is-invalid');
        }
    },
    watch: {
        'vendorData.delegation': function(newValue) {
            // alert(newValue)
        }
    }
}
</script>